module.exports = __webpack_public_path__ + "static/media/Portfolio.4394138b.png";